// extracted by mini-css-extract-plugin
var _1 = "IntegrationMentionCard-module__animatedBackground--AaaGU";
var _2 = "IntegrationMentionCard-module__content--MV7iX";
var _3 = "IntegrationMentionCard-module__hoverTarget--eYuV9";
var _4 = "IntegrationMentionCard-module__iconContainer--zzhs1";
var _5 = "IntegrationMentionCard-module__slackIcon--rl6C1";
var _6 = "IntegrationMentionCard-module__tag--bxPKn";
var _7 = "IntegrationMentionCard-module__tags--Wg4Vj";
export { _1 as "animatedBackground", _2 as "content", _3 as "hoverTarget", _4 as "iconContainer", _5 as "slackIcon", _6 as "tag", _7 as "tags" }
